import { Box } from "@mui/system";
import React from "react";
import { Typography } from "@mui/material";
import { useTheme } from "@emotion/react";
import PlayCircleOutlineRoundedIcon from "@mui/icons-material/PlayCircleOutlineRounded";
import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined";
import { useNavigate, useParams } from "react-router";

import CustomAvatar from "../CustomAvatar";
import RightLeftChecker from "../../../utils/RightLeftChecker";

const CommentReplayed = ({ cmData }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const params = useParams();

  const handleDisableClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };
  const conUrl = (type) => {
    let url;
    if (cmData.content_data.parent_type === "opinion") {
      url = `/table/${params.tableId}/opinions/${
        cmData.content_data.parent_id
      }/topics/${cmData.content_data.id}/${type === "post" ? "" : "comment"}`;
    }
    if (cmData.content_data.parent_type === "conversation") {
      url = `/table/${params.tableId}/discussions/${
        cmData.content_data.parent_id
      }/topics/${cmData.content_data.id}/${type === "post" ? "" : "comment"}`;
    }

    return url;
  };

  const handleNavigate = (e, type) => {
    e.stopPropagation();
    e.preventDefault();
    navigate(conUrl(type));
  };

  return (
    <Box
      onClick={(e) => handleNavigate(e, "post")}
      onContextMenu={handleDisableClick}
      sx={{
        display: "flex",
        border: "1px solid",
        borderColor: "mute.main",
        borderRadius: "4px",
        p: "4px",
        width: "100%",
        mb: "8px",
        cursor: "pointer",
      }}
    >
      <Box sx={{ mr: "4px" }}>
        <CustomAvatar
          borderSize={1.5}
          src={cmData.content_data.thumbnail}
          size={24}
          round='4px'
          alt={"avatar name"}
          borderColor={theme.palette.white.main}
        />
      </Box>
      <Box sx={{ display: "grid" }}>
        <Typography
          sx={{
            fontSize: "11px",
            fontWeight: "600",
            lineHeight: "14px",
            color: "secondary.main",
          }}
        >
          {cmData.content_data.post_author}
        </Typography>
        <Typography
          noWrap
          sx={{
            fontSize: "10px",
            lineHeight: "14px",
            mt: "auto",
            color: "darkMute.main",
            direction: RightLeftChecker(cmData.content_data.title)
              ? "rtl"
              : "ltr",
          }}
        >
          {cmData.content_data.title}
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          color: "darkMute.main",
          justifyContent: "start",
          ml: "auto",
        }}
      >
        <PlayCircleOutlineRoundedIcon
          sx={{ mx: "8px" }}
          onClick={(e) => handleNavigate(e, "post")}
        />
        <SmsOutlinedIcon onClick={(e) => handleNavigate(e, "cm")} />
      </Box>
    </Box>
  );
};

export default CommentReplayed;
